import { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { useSelector } from 'react-redux';
import { throttleRAF } from '../../../utils/throttle';
 
export default function useMachineGizmoEvents({ scene, camera, renderer }) {
  const rotatingMachineRef = useRef(null);
  const startAngleRef = useRef(0);
  const startRotationZRef = useRef(0);

  const orthoMode = useSelector((state) => state.mods.orthoMode);

  useEffect(() => {
    

    if (!scene || !camera || !renderer) {
      return;
    }

    
    const dom = renderer.domElement;
    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();

    const getWorldPoint = (event) => {
      const rect = dom.getBoundingClientRect();
      mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);

      const plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);
      const point = new THREE.Vector3();
      raycaster.ray.intersectPlane(plane, point);
      return point;
    };

    const handleMouseDown = (event) => {
      
      const point = getWorldPoint(event);
      const intersects = raycaster.intersectObjects(scene.children, true);

      

      // 🔍 Debug: Tüm tıklanan objeleri logla
      if (intersects.length > 0) {
        
      }

      // 🔍 Debug: Tüm rotate gizmo'ları logla
      const allRotateGizmos = intersects.filter(i => i.object?.userData?.type === 'rotateGizmo');
      if (allRotateGizmos.length > 0) {
        
      }

      // ✅ Sadece machine rotate gizmo'larını kontrol et
      const rotateHit = intersects.find(i =>
        i.object?.userData?.type === 'rotateGizmo' &&
        i.object?.userData?.parentMachineId // Machine gizmo olduğundan emin ol
      );
      
      if (rotateHit) {
        

        // ✅ Parent zincirini takip ederek machine'i bul
        // rotateGizmo -> offsetGroup -> machineGroup
        let machineGroup = null;
        let current = rotateHit.object.parent; // offsetGroup
        while (current) {
          if (current.userData?.type === 'machine') {
            machineGroup = current;
            break;
          }
          current = current.parent;
        }

        if (!machineGroup) {
          console.error('❌ machineGroup parent zincirinde bulunamadı!');
          return;
        }

        

        // offsetGroup'u userData.isOffsetGroup ile bul
        const offsetGroup = machineGroup?.children.find(child => child.userData?.isOffsetGroup === true);

        if (!offsetGroup) {
          console.warn('⚠️ offsetGroup bulunamadı!');
          return;
        }

        

        // ✅ Görsel merkez artık tam basePoint'te
        // Machine merkeze hizalı olduğu için offset yok
        const center = machineGroup.position.clone();

        const startVector = new THREE.Vector2(point.x - center.x, point.y - center.y);
        startAngleRef.current = Math.atan2(startVector.y, startVector.x);
        startRotationZRef.current = offsetGroup.rotation.z;
        rotatingMachineRef.current = offsetGroup;
        return;
      }
    };

    const handleMouseMove = (event) => {
      const point = getWorldPoint(event);

      if (rotatingMachineRef.current) {
        // ✅ Görsel merkez artık tam basePoint'te
        const center = rotatingMachineRef.current.parent.position;
        const currentVector = new THREE.Vector2(point.x - center.x, point.y - center.y);
        let currentAngle = Math.atan2(currentVector.y, currentVector.x);

        if (orthoMode) {
          const rawDelta = currentAngle - startAngleRef.current;
          const deltaDeg = THREE.MathUtils.radToDeg(rawDelta);
          const snappedDeg = Math.round(deltaDeg / 45) * 45;
          currentAngle = startAngleRef.current + THREE.MathUtils.degToRad(snappedDeg);
        }

        const delta = currentAngle - startAngleRef.current;
        rotatingMachineRef.current.rotation.z = startRotationZRef.current + delta;
        
        // Yeni toplam açıyı userData'ya kaydet (radyan olarak)
        rotatingMachineRef.current.parent.userData.angle = startRotationZRef.current + delta;
      }
    };

    const handleMouseUp = () => {
      if (rotatingMachineRef.current) {
        
        rotatingMachineRef.current = null;
      }
    };

    const throttledMouseMove = throttleRAF(handleMouseMove);

    dom.addEventListener('mousedown', handleMouseDown);
    dom.addEventListener('mousemove', throttledMouseMove);
    dom.addEventListener('mouseup', handleMouseUp);

    return () => {
      throttledMouseMove.cancel();
      dom.removeEventListener('mousedown', handleMouseDown);
      dom.removeEventListener('mousemove', throttledMouseMove);
      dom.removeEventListener('mouseup', handleMouseUp);
    };
  }, [scene, camera, renderer, orthoMode]);
}
